import React from 'react';
import useTheme from '@mui/material/styles/useTheme';
import { observer } from 'mobx-react';
import { Modal, Divider, Box, Button, Typography, Link } from '@mui/material';
import { useContext } from 'react';
import { AppContext } from '/@/app/AppContext';
//
import NewReleasesIcon from '@mui/icons-material/NewReleases';
//
import { AudioPlayer } from '/@/app/components/AudioPlayer';
import { Linkify } from '/@/app/linkify';
import { DynamicsChart } from '/@/app/components/DynamicsChart';


export const MeasurementModal = observer(({ modalState }) => {
    const theme = useTheme();
    const { userData } = useContext(AppContext);
    const currentPanel = useContext(AppContext).bootstrapData.panel;

    const closeCommentDialog = () => modalState.close();
    const mState = modalState.measurement;
    const modalOpen = mState !== null;
    const m = mState?.measurement;

    let dynamics = useContext(AppContext).bootstrapData?.panel_dynamics?.items?.[mState?.xlsxId || 0];
    if (dynamics && dynamics.length === 1) {
        dynamics = null;  // don't show dynamics with one item
    }

    return (
        <Modal
            open={modalOpen}
            onClose={closeCommentDialog}
        >
            <Box sx={{
                position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                maxHeight: '90vh',
                maxWidth: { xs: '95vw', sm: '90vw', md: '600px' },
                width: { xs: '95vw', sm: '90vw' },
                backgroundColor: 'white',
                padding: 3,
                borderRadius: 3,
                display: 'flex',
                flexDirection: 'column',
                outline: 'none',
            }}>
                {mState &&
                    <Box sx={{ overflowY: "auto", flex: "0 1 auto", overflowX: 'hidden', marginBottom: 1 }}>
                        <Typography variant="body1" gutterBottom>Комментарий к анализу</Typography>
                        <Box sx={{ display: "flex", flexFlow: "row nowrap", justifyContent: "space-between"}}>
                            <Typography variant="h5" gutterBottom>{mState.caption}</Typography>
                            <AudioPlayer audioSrc={mState.sound_link} sx={{
                                justifySelf: "left",
                            }} size="30px" hideCaption={true} />
                        </Box>
                        <Divider sx={{ marginBottom: 2 }} />
                        {dynamics &&
                            <DynamicsChart
                                data={dynamics}
                                currentPanel={currentPanel}
                                debugTools={userData.debug_mode}
                                sx={{ mb: 2 }}
                            />
                        }

                        <Typography variant="body1" component="div" gutterBottom>
                            {mState.value?.value &&
                                <>
                                    Ваш показатель: {" "}
                                    <Box component="span" sx={{ color: (mState.nonOptimal ? theme.palette.error.main : theme.palette.success.main) }}>
                                        {mState.value?.value ?
                                            Math.round(mState.value.value * 1000) / 1000
                                            : "нет данных"
                                        }{" "}{mState.units}
                                    </Box>
                                </>
                            }
                            {m?.target_range &&
                                <Box sx={{ color: (
                                        mState.value?.value !== null ?
                                            (mState.nonOptimal ? theme.palette.error.main : theme.palette.success.main)
                                            : "inherit")
                                }}>
                                    Оптимально: {m.target_range.replace(/(\d+),(\d+)/g, "$1.$2")}
                                </Box>
                            }
                        </Typography>
                        <Typography variant="body1" component="div" gutterBottom>
                            <Linkify text={m?.comments} />
                        </Typography>
                        {mState.article_link &&
                            <Link href={mState.article_link} target="_blank" sx={{ display: "flex", flexFlow: "row nowrap", alignItems: "center" }}>
                                <NewReleasesIcon sx={{ mr: 1 }}/> Обязательно прочитайте об этом анализе!
                            </Link>
                        }
                    </Box>
                }
                <Button sx={{ alignSelf: "center" }} onClick={closeCommentDialog}>Закрыть</Button>
            </Box>
        </Modal>
    )
});
